module.exports = __webpack_public_path__ + "static/media/propertyImg.e8764f3e.png";